import {AvailableUserChoices, MessageStatus, MessageType, ToolingType, VOTE_OPTION} from './enums';

export class chatMessage {
  seq: number = 0;
  messageId: string = '';
  tooling: any;
  toolingType: ToolingType = ToolingType.RAG_AGENT;
  messageType: MessageType = MessageType.HUMAN_MESSAGE;
  availableUserChoices: AvailableUserChoices[] = [];
  userChoice: AvailableUserChoices = AvailableUserChoices.NONE;
  messageStatus: MessageStatus = MessageStatus.DEFAULT;
  memorySummary: string = '';
  rawData: string = '';
  attachment: string = '';
  inputGuardrail: InputGuardrail | null = null;

  constructor(data: any) {
    if (data) {
      this.seq = data.seq;
      this.messageId = data.messageId;
      this.tooling = data.tooling;
      this.toolingType = data.toolingType;
      this.messageType = data.messageType;
      this.availableUserChoices = data.availableUserChoices;
      this.userChoice = data.userChoice;
      this.messageStatus = data.messageStatus;
      this.memorySummary = data.memorySummary;
      this.rawData = data.rawData;
      this.attachment = data.attachment;
      if (data.inputGuardrail) {
        this.inputGuardrail = new InputGuardrail(data.inputGuardrail);
      }
    }
  }
}

export class InputGuardrail {
  status: string | undefined;
  [key: string]: any;
  constructor(guardrailData: { [key: string]: any }) {
    for (const key in guardrailData) {
      if (guardrailData.hasOwnProperty(key)) {
        if (key === 'status') {
          this.status = guardrailData[key];
        } else {
          this[key] = new GuardrailDetail(
            guardrailData[key].call_id,
            guardrailData[key].raw_llm_output,
            guardrailData[key].validated_output,
            guardrailData[key].reask,
            guardrailData[key].validationPassed,
            guardrailData[key].error
          );
        }
      }
    }
  }
}


export class GuardrailDetail {
  call_id: string;
  raw_llm_output: string;
  validated_output: string;
  reask: any;
  validationPassed: boolean;
  error: any;

  constructor(call_id: string, raw_llm_output: string, validated_output: string, reask: any, validationPassed: boolean, error: any) {
    this.call_id = call_id;
    this.raw_llm_output = raw_llm_output;
    this.validated_output = validated_output;
    this.reask = reask;
    this.validationPassed = validationPassed;
    this.error = error;
  }
}
export class Vote {
  userFeedback: VOTE_OPTION;
  userNote: string;

  constructor(userFeedback: VOTE_OPTION,  userNote: string) {
    this.userFeedback = userFeedback;
    this.userNote = userNote;
  }
}
